import * as React from "react";
import Stack from "@mui/material/Stack";
import { Grid } from "@mui/material";
import axios from "axios";
import { genURL, genURLTEST } from "../../../_getjson";
import CustomBackdrop from "../../../Components/CustomBackdrop/Barckdrop";
import CustomDataGrid from "../../../Components/CustomDataGrid/CustomDataGrid";

const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },

  {
    field: "docNo",
    headerName: "เลขที่เอกสาร",
    width: 200,
    editable: false,
  },
  {
    field: "productCode",
    headerName: "เลขที่เอกสาร",
    width: 150,
    editable: false,
  },
  {
    field: "productName",
    headerName: "ชื่อสินค้า",
    width: 150,
    editable: false,
  },

  {
    field: "unitCode",
    headerName: "unitCode",
    width: 200,
    editable: false,
  },
  {
    field: "unitName",
    headerName: "หน่วย",
    width: 200,
    editable: false,
  },
  {
    field: "quantity",
    headerName: "ปริมาณ",
    width: 200,
    editable: false,
  },
  {
    field: "price",
    headerName: "ราคา/หน่วย",
    width: 200,
    editable: false,
  },
  ,
  {
    field: "discWord",
    headerName: "ลด",
    width: 200,
    editable: false,
  },
  {
    field: "saleName",
    headerName: "พนักงานขาย",
    width: 200,
    editable: false,
  },
  {
    field: "remarkSaleName",
    headerName: "หมายเหตุพนักงานขาย",
    width: 200,
    editable: false,
  },
  {
    field: "productSet",
    headerName: "PRODUCTSET",
    width: 200,
    editable: false,
  },
  {
    field: "stockType",
    headerName: "STOCKTYPE",
    width: 200,
    editable: false,
  },
  {
    field: "productSetCode",
    headerName: "PRODUCTSETCODE",
    width: 200,
    editable: false,
  },
  {
    field: "grDateX",
    headerName: "GRDATEX",
    width: 200,
    editable: false,
  },
  {
    field: "warehouse",
    headerName: "WAREHOUSE",
    width: 200,
    editable: false,
  },
  {
    field: "location",
    headerName: "LOCATION",
    width: 200,
    editable: false,
  },
  {
    field: "refDocNo",
    headerName: "REFDOCNO",
    width: 200,
    editable: false,
  },
];

export default function Selectsaleref2sub(props) {
  const [state, setState] = React.useState({
    openbackdrop: false,
    rows: [],
  });
  React.useEffect(() => {
    loadData();

    return () => {};
  }, []);

  async function loadData() {
    console.log("props", props.docNo);

    // เตรียมเลขที่เอกสาร
    let docNoStr = "'";

    for (let index = 0; index < props.docNo.length; index++) {
      docNoStr += await props.docNo[index].docNo;
      if (index < props.docNo.length - 1) {
        docNoStr += await "','";
      }
      if (index === props.docNo.length - 1) {
        docNoStr += await "'";
      }
    }

    let j = JSON.stringify(docNoStr);
    console.log(j);

    //await setState((prevState) => ({ ...prevState, openbackdrop: true }))
    let rs = await axios.get(
      genURL("CSV_SALEREFDOCNO2/searchSubData?docNo=" + docNoStr)
    );
    // let rs = await axios.get(genURLTEST("searchSubData?docNo=" + docNoStr))
    // let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}&top=${state.top}`))
    let element = [];
    console.log(rs);

    if (rs.data.length > 0) {
      //  console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          productCode: rs.data[index].PRODUCTCODE,
          productName: rs.data[index].PRODUCTNAME,
          docNo: rs.data[index].DOCNO,
          unitCode: rs.data[index].UNITCODE,
          unitName: rs.data[index].UNITNAME,
          quantity: rs.data[index].QUANTITY,
          price: rs.data[index].UNITPRICE,
          discWord: rs.data[index].DISCWORD,
          saleName: rs.data[index].SALENAME,
          remarkSaleName: rs.data[index].SALEREMARK,
          productSet: rs.data[index].PRODUCTSET,
          stockType: rs.data[index].STOCKTYPE,
          productSetCode: rs.data[index].PRODUCTSETCODE,
          refDocNo: rs.data[index].REFDOCNO,
          warehouse: rs.data[index].WAREHOUSEX,
          location: rs.data[index].LOCATIONX,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      await setState((prevState) => ({ ...prevState, rows: element }));
    } else {
      await setState((prevState) => ({
        ...prevState,
        rows: [],
        openbackdrop: false,
      }));
    }
    await setState((prevState) => ({ ...prevState, openbackdrop: false }));
  }
  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = async (e) => {
    await props.Dataselect(e);
  };
  return (
    <Stack spacing={2} direction="row" sx={{ padding: 2 }}>
      {state.rows.length > 0 ? (
        <CustomDataGrid
          datacolumns={columns}
          datarows={state.rows}
          rowHeight={38}
          Dataintable={(e) => resData(e)}
          Dataintableremove={(e) => removeresData(e)}
          startRow={1}
          option={[{ add: false, del: false, select: true }]}
          checkboxSelection
          onRowClick={(e) => selcetRow([e.row])}
          // disableColumnSelector
          Dataselect={(e) => selcetRow(e)}
          RowsModelChange={(_) => console.log("RowsModelChange")}
          from={"s" + props.from}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign={"center"}>
            ไม่พบข้อมูล
          </Grid>
        </Grid>
      )}
      <CustomBackdrop open={state.openbackdrop} />
    </Stack>
  );
}
